<div class="container">
  <div class="page-header-title" i18n>Reports</div>
  <div class="page-sub-header" i18n>View statistical performance for your selected templates.</div>

  <div class="content-card-background">
    <div class="header-row clearfix">
      @if (contentItem !== null) {
        <div class="table-body-left clearfix">
          <div class="content-icon-border">
            @switch (contentItem.type) {
              @case (ImageTypeEnum.Video) {
                <i class="fas fa-play-circle content-icon"></i>
              }
              @case (ImageTypeEnum.Image) {
                <i class="far fa-image-polaroid content-icon"></i>
              }
              @case (ImageTypeEnum.GIF) {
                <img src="assets/icons/gif.svg" class="content-icon" alt="" />
              }
            }
          </div>
          <div class="video-details">
            <div class="clearfix video-top-row">
              <h1 class="video-id">{{ contentItem.title }}</h1>
            </div>
            <div class="video-bottom-row">
              @if (contentItem.templateItem.template.items.length === 1) {
                <p>
                  {{ contentItem.templateItem.template.title }} &nbsp; | &nbsp; {{ contentItem.views.totalCount }}
                  <ng-container i18n>Views</ng-container>
                </p>
              } @else {
                <p>
                  {{ contentItem.templateItem.template.title }} / {{ contentItem.templateItem.title }} &nbsp; | &nbsp;
                  {{ contentItem.views.totalCount }}
                  <ng-container i18n>Views</ng-container>
                </p>
              }
            </div>
          </div>
        </div>
      }

      <div class="header-wrapper" [style.float]="hideTemplateSelect ? 'right': 'left'">
        @if (!hideTemplateSelect) {
          <select class="template-select header-select grow" [formControl]="templateSelect">
            <option [ngValue]="null" i18n>All templates</option>
            <option selected [ngValue]="'-1'" i18n>Active templates</option>
            @for (item of templateQueryItems; track item.type + ':' + item.id) {
              <option [ngValue]="item">{{ item.title }}</option>
            }
          </select>
        }
        <select class="month-select header-select" [formControl]="timeSelection">
          @for (option of specificTimeSelections; track option) {
            <option [ngValue]="option">{{ option.title }}</option>
          }
          <option selected [ngValue]="null" i18n>All</option>
        </select>
        @if (loading) {
          <button class="generate-button" i18n>Loading...</button>
        } @else {
          <button class="generate-button" i18n (click)="generateReport()">Generate report</button>
        }
      </div>
    </div>

    <div class="stats-wrapper">
      <div class="content-stats-wrapper">
        <h2 i18n>Content stats</h2>
        <div class="chart-bar-wrapper">
          <div class="chart-bar-inactive"></div>
          @if (stats.viewCount > 0) {
            <div class="chart-bar-active" [ngStyle]="{'width': '100%'}">
              <div class="chart-bar-viewed"></div>
            </div>
          }
          @if (stats.viewCount === 0 || loading === true) {
            <div class="chart-bar-active">
              <div class="chart-bar-viewed"></div>
            </div>
          }
        </div>
        <div class="chart-bar-text-wrapper">
          <i class="far fa-eye"></i>
          @if (stats.viewCount === initialValue) {
            <h3>{{ stats.viewCount | reportData }}</h3>
          } @else {
            <h3>{{ stats.viewCount | shortNumber }}</h3>
          }
          <p i18n>Viewed content</p>
        </div>
        <div class="chart-bar-wrapper">
          <div class="chart-bar-inactive"></div>
          <div class="chart-bar-active" [ngStyle]="{'width': createdChartValue + '%'}">
            <div class="chart-bar-created"></div>
          </div>
        </div>
        <div class="chart-bar-text-wrapper">
          <i class="far fa-play-circle"></i>
          @if (stats.createdContentCount === initialValue) {
            <h3>{{ stats.createdContentCount | reportData }}</h3>
          } @else {
            <h3>{{ stats.createdContentCount | shortNumber }}</h3>
          }
          <p i18n>Unique content</p>
        </div>
      </div>

      <div class="overall-stats-wrapper">
        <h2 i18n>Overall stats</h2>
        <div class="stats-row">
          <div class="overall-stats-item">
            <div class="overall-stats-icon-background">
              <i class="far fa-play-circle"></i>
            </div>
            <div class="overall-stats-details">
              @if (stats.createdContentCount === initialValue) {
                <h6>{{ stats.createdContentCount | reportData }}</h6>
              } @else {
                <h6>{{ stats.createdContentCount | shortNumber }}</h6>
              }
              <p i18n>Unique content</p>
            </div>
          </div>
        </div>
        <div class="stats-row">
          <div class="overall-stats-item">
            <div class="overall-stats-icon-background">
              <i class="far fa-eye"></i>
            </div>
            <div class="overall-stats-details">
              @if (stats.viewCount === initialValue) {
                <h6>{{ stats.viewCount | reportData }}</h6>
              } @else {
                <h6>{{ stats.viewCount | shortNumber }}</h6>
              }
              <p i18n>Viewed content</p>
            </div>
          </div>
          <div class="overall-stats-item">
            <div class="overall-stats-icon-background right-icon">
              <i class="fas fa-play"></i>
            </div>
            <div class="overall-stats-details">
              @if (stats.totalPlayTotalCount === initialValue) {
                <h6>{{ stats.totalPlayTotalCount | reportData }}</h6>
              } @else {
                <h6>{{ stats.totalPlayTotalCount | shortNumber }}</h6>
              }
              <p i18n>Plays</p>
            </div>
          </div>
        </div>
        <div class="stats-row">
          <div class="overall-stats-item">
            <div class="overall-stats-icon-background">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="overall-stats-details">
              @if (stats.completedPlays === initialValue) {
                <h6>{{ stats.completedPlays | reportData }}</h6>
              } @else {
                <h6>{{ stats.completedPlays | shortNumber }}</h6>
              }
              <p i18n>Completed plays</p>
            </div>
          </div>
          <div class="overall-stats-item">
            <div class="overall-stats-icon-background right-icon">
              <img src="assets/icons/alarm-green.svg" class="content-icon" alt="" />
            </div>
            <div class="overall-stats-details">
              @if (stats.totalPlayAverageTime && stats.totalPlayAverageTime !== initialValue && stats.totalPlayAverageTime > 0) {
                <h6>{{ stats.totalPlayAverageTime * 1000 | date: 'm'}}m {{ stats.totalPlayAverageTime * 1000 | date: 'ss'}}s</h6>
              }
              @if (stats.totalPlayAverageTime === null) {
                <h6>{{ stats.totalPlayAverageTime | reportData }}</h6>
              }
              @if (stats.totalPlayAverageTime !== null && stats.totalPlayAverageTime === 0 || stats.totalPlayAverageTime === initialValue) {
                <h6>-</h6>
              }
              <p i18n>Average playing time</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="graph">
      <h2>Timeline</h2>
      <div class="graph-select-row">
        <div class="graph-select-card" (click)="getGraphData(ObjectTypeEnum.View)">
          <div
            class="selected-bar"
            [ngStyle]="graphSelection$.value === ObjectTypeEnum.View && {'background-color': '#82FDC8'} || {}"></div>
          <div class="graph-select-wrapper">
            <i class="far fa-eye"></i>
            <div class="graph-select-details">
              @if (stats.viewCount === initialValue) {
                <h3>{{ stats.viewCount | reportData }}</h3>
              } @else {
                <h3>{{ stats.viewCount | shortNumber }}</h3>
              }
              <p i18n>Viewed content</p>
            </div>
          </div>
        </div>
        @if (contentId === null) {
          <div class="graph-select-card" (click)="getGraphData(ObjectTypeEnum.Content)">
            <div
              class="selected-bar"
              [ngStyle]="graphSelection$.value === ObjectTypeEnum.Content && {'background-color': '#82FDC8'} || {}"></div>
            <div class="graph-select-wrapper">
              <i class="far fa-play-circle"></i>
              <div class="graph-select-details">
                @if (stats.createdContentCount === initialValue) {
                  <h3>{{ stats.createdContentCount | reportData }}</h3>
                } @else {
                  <h3>{{ stats.createdContentCount | shortNumber }}</h3>
                }
                <p i18n>Unique content</p>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="graph-container" id="graph-container"></div>
    </div>

    <div class="summary">
      <h2 i18n>Summary</h2>
      <div class="summary-row">
        <div class="summary-wrapper summary-wrapper-left">
          <p i18n>Unique content resulted in a number of views.</p>
          <div class="summary-detail-card">
            <div class="upper-row">
              <div class="summary-detail-wrapper">
                <i class="far fa-play-circle"></i>
                <div class="summary-detail-right">
                  @if (stats.createdContentCount === initialValue) {
                    <h3>{{ stats.createdContentCount | reportData }}</h3>
                  } @else {
                    <h3>{{ stats.createdContentCount | shortNumber }}</h3>
                  }
                  <p i18n>Unique content</p>
                </div>
              </div>
            </div>
            <div class="lower-row">
              <div class="summary-details summary-details-one">
                <div class="summary-detail-wrapper">
                  <div class="triangle"></div>
                  <i class="far fa-eye"></i>
                  <div class="summary-detail-right">
                    @if (stats.viewCount === initialValue) {
                      <h3>{{ stats.viewCount | reportData }}</h3>
                    } @else {
                      <h3>{{ stats.viewCount | shortNumber }}</h3>
                    }
                    <p i18n>Viewed content</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="summary-wrapper">
          <p i18n>A created content item resulted on average in a number of views.</p>
          <div class="summary-detail-card">
            <div class="upper-row">
              <div class="summary-detail-wrapper">
                <i class="far fa-play-circle"></i>
                <div class="summary-detail-right">
                  @if (stats.createdContentCount <= 0) {
                    <h3>{{ stats.createdContentCount | reportData }}</h3>
                  } @else {
                    <h3>
                      {{ stats.createdContentCount / stats.createdContentCount | shortNumber | number: '1.0-0'}}
                    </h3>
                  }
                  <p i18n>Content item</p>
                </div>
              </div>
            </div>
            <div class="lower-row">
              <div class="summary-details summary-details-one">
                <div class="summary-detail-wrapper">
                  <div class="triangle"></div>
                  <i class="far fa-eye"></i>
                  <div class="summary-detail-right">
                    @if (stats.createdContentCount <= 0) {
                      <h3>{{ stats.createdContentCount | reportData }}</h3>
                    } @else {
                      <h3>
                        {{ stats.viewCount / stats.createdContentCount | shortNumber | number: '1.0-0'}}
                      </h3>
                    }
                    <p i18n>Viewed content</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="summary-row">
        <div class="summary-wrapper">
          <p i18n>Unique content in percentages per content type.</p>
          <div class="summary-detail-card">
            <div class="upper-row">
              <div class="summary-detail-wrapper">
                <i class="far fa-play-circle"></i>
                <div class="summary-detail-right">
                  @if (stats.createdContentCount === initialValue) {
                    <h3>{{ stats.createdContentCount | reportData }}</h3>
                  } @else {
                    <h3>{{ stats.createdContentCount | shortNumber }}</h3>
                  }
                  <p i18n>Unique content</p>
                </div>
              </div>
            </div>
            <div class="lower-row">
              <div class="summary-details summary-details-third-left">
                <div class="summary-detail-wrapper">
                  <div class="triangle"></div>
                  <i class="far fa-image-polaroid content-icon"></i>
                  <div class="summary-detail-right">
                    @if (stats.createdContentCount > 0) {
                      <h3>{{ stats.imageTotalCount / stats.createdContentCount * 100 | number: '1.0-0' }}%</h3>
                    }
                    @if (stats.createdContentCount === 0) {
                      <h3>0%</h3>
                    }
                    @if (stats.createdContentCount === initialValue) {
                      <h3>{{ stats.createdContentCount | reportData }}</h3>
                    }
                    <p i18n>Images</p>
                  </div>
                </div>
              </div>
              <div class="summary-details summary-details-third-middle">
                <div class="summary-detail-wrapper">
                  <div class="triangle"></div>
                  <i class="fas fa-play-circle"></i>
                  <div class="summary-detail-right">
                    @if (stats.createdContentCount > 0) {
                      <h3>{{ stats.videoTotalCount / stats.createdContentCount * 100 | number: '1.0-0' }}%</h3>
                    }
                    @if (stats.createdContentCount === 0) {
                      <h3>0%</h3>
                    }
                    @if (stats.createdContentCount === initialValue) {
                      <h3>{{ stats.createdContentCount | reportData }}</h3>
                    }
                    <p i18n>Videos</p>
                  </div>
                </div>
              </div>
              <div class="summary-details summary-details-third-right">
                <div class="summary-detail-wrapper">
                  <div class="triangle"></div>
                  <img src="assets/icons/gif-black.svg" class="content-icon" alt="" />
                  <div class="summary-detail-right">
                    @if (stats.createdContentCount > 0) {
                      <h3>{{ stats.gifTotalCount / stats.createdContentCount * 100 | number: '1.0-0' }}%</h3>
                    }
                    @if (stats.createdContentCount === 0) {
                      <h3>0%</h3>
                    }
                    @if (stats.createdContentCount === initialValue) {
                      <h3>{{ stats.createdContentCount | reportData }}</h3>
                    }
                    <p i18n>GIF Images</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (showVideoSummary) {
      <div class="detailed-summary">
        <h2 i18n>Video summary</h2>
        <div class="summary-row">
          <div class="summary-wrapper summary-wrapper-left">
            <p i18n>A single created content item resulted on average in a number of plays and completed plays.</p>
            <div class="summary-detail-card">
              <div class="upper-row">
                <div class="summary-detail-wrapper">
                  <i class="far fa-play-circle"></i>
                  <div class="summary-detail-right">
                    @if (stats.createdContentCount <= 0) {
                      <h3>{{ stats.createdContentCount | reportData }}</h3>
                    } @else {
                      <h3>
                        {{ stats.createdContentCount / stats.createdContentCount | shortNumber | number: '1.0-0'}}
                      </h3>
                    }
                    <p i18n>Content item</p>
                  </div>
                </div>
              </div>
              <div class="lower-row">
                <div class="summary-details summary-details-half-left">
                  <div class="summary-detail-wrapper">
                    <div class="triangle"></div>
                    <i class="fas fa-play"></i>
                    <div class="summary-detail-right">
                      @if (stats.createdContentCount <= 0) {
                        <h3>{{ stats.createdContentCount | reportData }}</h3>
                      } @else {
                        <h3>
                          {{ stats.totalPlayTotalCount / stats.createdContentCount | shortNumber | number: '1.0-0'}}
                        </h3>
                      }
                      <p i18n>Plays</p>
                    </div>
                  </div>
                </div>
                <div class="summary-details summary-details-half-right">
                  <div class="summary-detail-wrapper">
                    <div class="triangle"></div>
                    <i class="fas fa-check-circle"></i>
                    <div class="summary-detail-right">
                      @if (stats.createdContentCount <= 0) {
                        <h3>{{ stats.createdContentCount | reportData }}</h3>
                      } @else {
                        <h3>
                          {{ stats.completedPlays / stats.createdContentCount | shortNumber | number: '1.0-0'}}
                        </h3>
                      }
                      <p i18n>Completed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="summary-wrapper">
            <p i18n>The percentage of completed plays in comparison to the number total plays and total views.</p>
            <div class="summary-detail-card">
              <div class="upper-row">
                <div class="summary-detail-wrapper">
                  <i class="fas fa-check-circle"></i>
                  <div class="summary-detail-right">
                    @if (stats.completedPlays === initialValue) {
                      <h3>{{ stats.completedPlays | reportData }}</h3>
                    } @else {
                      <h3>{{ stats.completedPlays | shortNumber }}</h3>
                    }
                    <p i18n>Completed plays</p>
                  </div>
                </div>
              </div>
              <div class="lower-row">
                <div class="summary-details summary-details-half-left">
                  <div class="summary-detail-wrapper">
                    <div class="triangle"></div>
                    <i class="fas fa-play"></i>
                    <div class="summary-detail-right">
                      @if (stats.completedPlays > 0) {
                        <h3>{{ stats.completedPlays / stats.totalPlayTotalCount * 100 | number: '1.0-0' }}%</h3>
                      }
                      @if (stats.completedPlays === 0) {
                        <h3>0%</h3>
                      }
                      @if (stats.completedPlays === initialValue) {
                        <h3>{{ stats.completedPlays | reportData}}</h3>
                      }
                      <p i18n>Of total plays</p>
                    </div>
                  </div>
                </div>
                <div class="summary-details summary-details-half-right">
                  <div class="summary-detail-wrapper">
                    <div class="triangle"></div>
                    <i class="far fa-eye"></i>
                    <div class="summary-detail-right">
                      @if (stats.completedPlays > 0) {
                        <h3>{{ stats.completedPlays / stats.viewCount * 100 | number: '1.0-0' }}%</h3>
                      }
                      @if (stats.completedPlays === 0) {
                        <h3>0%</h3>
                      }
                      @if (stats.completedPlays === initialValue) {
                        <h3>{{ stats.completedPlays | reportData }}</h3>
                      }
                      <p i18n>Of total views</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="summary-row">
          <div class="summary-wrapper">
            <p i18n>How much a single video was played on average.</p>
            <div class="summary-detail-card">
              <div class="lower-row">
                <div class="summary-details summary-details-full">
                  <div class="summary-detail-wrapper">
                    <img src="assets/icons/alarm.svg" class="content-icon" alt="" />
                    <div class="summary-detail-right">
                      @if (stats.totalPlayAverageTime && stats.totalPlayAverageTime !== initialValue && stats.totalPlayAverageTime > 0) {
                        <h3>{{ stats.totalPlayAverageTime * 1000 | date: 'm'}}m {{ stats.totalPlayAverageTime * 1000 | date: 'ss'}}s</h3>
                      }
                      @if (stats.totalPlayAverageTime === null) {
                        <h3>{{ stats.totalPlayAverageTime | reportData }}</h3>
                      }
                      @if (
                        stats.totalPlayAverageTime !== null && stats.totalPlayAverageTime === 0 || stats.totalPlayAverageTime === initialValue
                      ) {
                        <h3>-</h3>
                      }
                      <p i18n>Average playing time</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="content-card-background top-ten-card">
    @if (contentId === null) {
      <div class="top-ten-views">
        <h2 i18n>Top 10 views</h2>
        <div class="top-ten-header">
          <select class="template-select header-select grow" [formControl]="topTenTemplateSelect">
            @for (item of templateQueryItems; track item.type + ':' + item.id) {
              <option [ngValue]="item">{{ item.title }}</option>
            }
          </select>
          <select class="month-select header-select" [formControl]="monthSelection">
            @for (option of monthSelectionOptions; track option) {
              <option [ngValue]="option">{{ option.title }}</option>
            }
          </select>
          @if (topTenLoading) {
            <button class="generate-button" i18n>Loading</button>
          } @else {
            <button class="generate-button" i18n (click)="generateTopTen()">Generate top 10</button>
          }
        </div>
        @if (top10Content.length < 1 && topTenLoading === false) {
          <h4 class="no-content" i18n>No content found</h4>
        }
        <ng-container>
          @for (item of top10Content; track item) {
            <li class="content-row">
              <div class="content-link">
                <div class="content-icon-bg" (click)="toContentView(item.content.id)">
                  @switch (item.content.type) {
                    @case (ImageTypeEnum.Video) {
                      <i class="fas fa-play-circle content-icon"></i>
                    }
                    @case (ImageTypeEnum.Image) {
                      <i class="far fa-image-polaroid content-icon"></i>
                    }
                    @case (ImageTypeEnum.GIF) {
                      <img src="assets/icons/gif.svg" class="content-icon" alt="" />
                    }
                  }
                </div>
                <div class="content-details">
                  <div class="content-details-top">
                    <h1 class="content-details-title" (click)="toContentView(item.content.id)">{{ item.content.title }}</h1>
                  </div>
                  <div class="content-details-bottom">
                    @if (item.content.templateItem.template.items.length === 1) {
                      <p>
                        {{ item.content.templateItem.template.title }} &nbsp; | &nbsp; {{ item.viewCount }}
                        <ng-container i18n>Views</ng-container>
                      </p>
                    } @else {
                      <p>
                        {{ item.content.templateItem.template.title }} / {{ item.content.templateItem.title }} &nbsp; | &nbsp;
                        {{ item.viewCount }} <ng-container i18n>Views</ng-container>
                      </p>
                    }
                  </div>
                </div>
              </div>
            </li>
          }
        </ng-container>
      </div>
    }
  </div>
</div>
